import ModalButtonsConfig from "./ModalButtonsConfig";

export default class Modal {
  constructor() {
    this.modal = document.createElement("axs-modal");
    this.modal.addEventListener("modalClosed", () => {
      this.close();
    });
    document.body.appendChild(this.modal);

    this.content = document.createElement("div");
    this.modal.appendChild(this.content);
  }

  render(headerConfig, content, buttonsConfig = null) {
    this.modal.header = headerConfig.title;
    this.modal.headerIcon = headerConfig.icon;
    this.modal.error = headerConfig.error ?? false;
    this.modal.info = headerConfig.info ?? false;
    this.modal.warning = headerConfig.warning ?? false;
    this.modal.success = headerConfig.success ?? false;
    while (this.content.firstChild) {
      this.content.removeChild(this.content.firstChild);
    }
    this.content.appendChild(content);
    if (buttonsConfig instanceof ModalButtonsConfig) {
      this.modal.primaryButtonText = buttonsConfig.primaryButtonText;
      this.modal.primaryButtonIcon = buttonsConfig.primaryButtonIcon;
      this.modal.primaryButtonDisabled = buttonsConfig.primaryButtonDisabled;
      this.modal.secondaryButtonText = buttonsConfig.secondaryButtonText;
      this.modal.secondaryButtonIcon = buttonsConfig.secondaryButtonIcon;
      this.modal.secondaryButtonDisabled = buttonsConfig.secondaryButtonDisabled;

      if (buttonsConfig.primaryButtonHandler) {
        this.modal.addEventListener('primaryButtonClicked', () => {
          buttonsConfig.primaryButtonHandler();
        });
      }
      if (buttonsConfig.secondaryButtonHandler) {
        this.modal.addEventListener('secondaryButtonClicked', () => {
          buttonsConfig.secondaryButtonHandler();
        });
      }

    }
    this.modal.visible = true;
  }

  close = () => {
    this.content = null;
    this.modal.remove();
  }

  setVisible = (visible) => {
    this.modal.visible = visible;
  };

  setPrimaryButtonDisabled = (value) => {
    this.modal.primaryButtonDisabled = value;
  };

  setSecondaryButtonDisabled = (value) => {
    this.modal.secondaryButtonDisabled = value;
  };

};
